import "./Products.scss";
import ProductCard from "./ProductCard";

const Products = ({ products }) => {
  // console.log(products);
  return (
    <div className="product-list">
      {/* {products.map((product) => (
        <div key={product.id}>
          <div>
            <h3>{product.price}</h3>
          </div>
          <img src={product.image} alt={product.title} width="100px" />
          <div>
            <h2>{product.title}</h2>
          </div>
        </div>
      ))} */}
        {/* 2.yöntem */}

      {/* {products.map(({ price, title, image, id }) => (
        <div key={id}>
          <div>
            <h3>{price}</h3>
          </div>
          <img src={image} alt={title} width="100px" />
          <div>
            <h2>{title}</h2>
          </div>
        </div>
      ))} */}

      {/* 3.Yöntem bir alt Componente gönderme */}

      {
      products.map ((product)=> (
      <ProductCard key={product.id} product={product}/>
      )) }
    </div>
  );
};

export default Products;
